import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATklEQVR42n2NywqAIBRE/f8vK8pt2tralPRAihK54wPUnQNnZnNgGNpxLPZhfvRiQxcY5j2tvr8qmNdCqhNcrhgnBS4W6OupQg4RFfKFB8//e1/S2BrSAAAAAElFTkSuQmCC"};
